import addSeconds from 'date-fns/add_seconds'
import format from 'date-fns/format'

export default (seconds: number) => {
  const helperDate = addSeconds(new Date(0), seconds)
  return format(helperDate, 'mm[min]ss')
}
